/* Modulo FAQ Tabs — topic tabs (roving-tabindex + arrow keys + traveling ink
   underline) over a single-open hairline accordion per panel. Vanilla IIFE.
   Injected sections don't load the extension's moduloLazyInit, so we init on
   DOMContentLoaded and re-init on shopify:section:load (theme editor). */
(function () {
  'use strict';
  if (typeof window === 'undefined') return;

  // One window resize listener for the whole page — it re-syncs every live
  // section. A per-instance listener would leak on each theme-editor re-render
  // (the fresh node lacks the ftBound guard, so initSection re-runs), pinning
  // detached nodes in memory via the handler's closure.
  var globalResizeBound = false;
  function bindGlobalResize() {
    if (globalResizeBound) return;
    globalResizeBound = true;
    window.addEventListener('resize', function () {
      var live = document.querySelectorAll('[data-modulo-ft]');
      for (var i = 0; i < live.length; i++) {
        if (typeof live[i].__moduloFtSync === 'function') live[i].__moduloFtSync();
      }
    }, { passive: true });
  }

  function initSection(root) {
    if (root.dataset.ftBound === '1') return;
    root.dataset.ftBound = '1';

    var tablist = root.querySelector('[role="tablist"]');
    var tabs = Array.prototype.slice.call(root.querySelectorAll('.modulo-ft__tab[role="tab"]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('.modulo-ft__panel[data-panel]'));
    if (!tablist || !tabs.length) return;

    function moveInk(tab) {
      if (!tab) return;
      tablist.style.setProperty('--ink-x', tab.offsetLeft + 'px');
      tablist.style.setProperty('--ink-w', tab.offsetWidth + 'px');
    }

    function activate(tab, moveFocus) {
      tabs.forEach(function (t) {
        var on = t === tab;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.setAttribute('tabindex', on ? '0' : '-1');
      });
      panels.forEach(function (p) {
        var on = p.getAttribute('data-panel') === tab.getAttribute('data-tab');
        p.classList.toggle('is-active', on);
        if (on) { p.removeAttribute('hidden'); } else { p.setAttribute('hidden', ''); }
      });
      moveInk(tab);
      if (moveFocus) tab.focus();
    }

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { activate(tab, false); });
      tab.addEventListener('keydown', function (e) {
        var idx = null;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') idx = (i + 1) % tabs.length;
        else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') idx = (i - 1 + tabs.length) % tabs.length;
        else if (e.key === 'Home') idx = 0;
        else if (e.key === 'End') idx = tabs.length - 1;
        if (idx !== null) { e.preventDefault(); activate(tabs[idx], true); }
      });
    });

    // Accordion rows — single-open within a panel.
    var items = Array.prototype.slice.call(root.querySelectorAll('.modulo-ft__item[data-qa]'));
    items.forEach(function (item) {
      var btn = item.querySelector('.modulo-ft__trigger');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var open = item.getAttribute('data-open') === 'true';
        var panel = item.closest('.modulo-ft__panel');
        if (!open && panel) {
          panel.querySelectorAll('.modulo-ft__item[data-open="true"]').forEach(function (other) {
            other.setAttribute('data-open', 'false');
            var ob = other.querySelector('.modulo-ft__trigger');
            if (ob) ob.setAttribute('aria-expanded', 'false');
          });
        }
        item.setAttribute('data-open', open ? 'false' : 'true');
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
      });
    });

    // Keep the ink underline aligned after layout / font-load / mobile scroll.
    function sync() { moveInk(root.querySelector('.modulo-ft__tab[aria-selected="true"]') || tabs[0]); }
    root.__moduloFtSync = sync;
    requestAnimationFrame(sync);
    bindGlobalResize();
    tablist.addEventListener('scroll', sync, { passive: true });
    if (document.fonts && document.fonts.ready) { document.fonts.ready.then(sync); }
  }

  function bootstrap(scope) {
    var els = (scope || document).querySelectorAll('[data-modulo-ft]');
    for (var i = 0; i < els.length; i++) initSection(els[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { bootstrap(); });
  } else {
    bootstrap();
  }
  // Theme editor: re-init when this section is (re)rendered.
  document.addEventListener('shopify:section:load', function (e) { bootstrap(e.target); });
})();
